import { addCategory } from '../../../actions/siteadmin/Category/addCategory';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import { demoRestriction } from '../../../actions/demoRestriction';

async function submit(values, dispatch) {

	const isRestrict = await dispatch(demoRestriction({ restrictType: 'category', restrictValue: values?.id }));
	if (isRestrict) return;

	if (!values.logoImage) {
		showToaster({ messageId: 'categoryLogo', toasterType: 'error' });
		return;
	}

	if (!values.bannerImage) {
		showToaster({ messageId: 'categoryBanner', toasterType: 'error' });
		return;
	}

	const isPopular = values.isPopular === true || values.isPopular === 'true' || values.isPopular === 1;
	const isJobPhotoRequired = values.isJobPhotoRequired === true || values.isJobPhotoRequired === 'true' || values.isJobPhotoRequired === 1;


	await dispatch(
		addCategory(
			values.id,
			values.name,
			values.description,
			values.logoImage,
			values.bannerImage,
			isPopular,
			isJobPhotoRequired,
			values.travellingPrice,
			values.userServiceFeeValue,
			values.partnerServiceFeeValue,
			values.pricingType,
			values.status,
			values.currency,
			values.icon,
			values.slug,
			values.metaTitle,
			values.metaDescription,
			values.displayOrder,
		)
	)
}

export default submit;